import { useQuery } from '@tanstack/react-query';

import { fetchPublicPolicies, PUBLIC_POLICIES_KEY } from '@/features/legal/api/policies';

/**
 * The policies a new merchant must accept to register, as the server lists them.
 *
 * Read from the API rather than written into the form: which policies are
 * required, and at which version, is the platform owner's decision and changes
 * without a deploy. The server checks again at registration and has the final
 * word - a list that failed to load here sends nothing, and the server's
 * refusal names what is missing.
 */
export function useSignupPolicies() {
  const query = useQuery({
    queryKey: PUBLIC_POLICIES_KEY,
    queryFn: fetchPublicPolicies,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  const required = (query.data ?? []).filter((policy) => policy.requires_acceptance);
  return { required, refetch: query.refetch, isLoading: query.isLoading };
}
